import { EllipsisText, type GridColDef } from '@shared/components';

import { type AdminQuestionnaireExportItem } from './types';

export const columns: GridColDef<AdminQuestionnaireExportItem>[] = [
  {
    field: 'examDate',
    headerName: 'Exam Date',
    sortable: false,
    width: 120,
  },
  {
    field: 'examTime',
    headerName: 'Time',
    sortable: false,
    width: 116,
  },
  {
    field: 'examCenterCode',
    headerName: 'Exam Center',
    sortable: false,
    width: 116,
    renderCell: ({ row }) => <EllipsisText>{row.examCenterCode}</EllipsisText>,
  },
  {
    field: 'examCenterName',
    headerName: 'Exam Center Name',
    sortable: false,
    minWidth: 170,
    renderCell: ({ row }) => <EllipsisText>{row.examCenterName}</EllipsisText>,
  },
  {
    field: 'round',
    headerName: 'Round',
    sortable: false,
    width: 70,
    align: 'center',
  },
  {
    field: 'regType',
    headerName: 'Reg Type',
    sortable: false,
    width: 89,
  },
  {
    field: 'title',
    headerName: 'Title',
    flex: 1,
    sortable: false,
    minWidth: 265,
    renderCell: ({ row }) => <EllipsisText>{row.title}</EllipsisText>,
  },
  {
    field: 'location',
    headerName: 'Location',
    flex: 1,
    sortable: false,
    minWidth: 265,
    renderCell: ({ row }) => <EllipsisText>{row.location}</EllipsisText>,
  },
  {
    field: 'province',
    headerName: 'Province',
    sortable: false,
    width: 142,
  },
  {
    field: 'responses',
    headerName: 'Responses',
    sortable: false,
    type: 'string',
    width: 104,
  },
];
